<template>
  <div>
    <div>
      <LoaderTuin :is-loading="loader" />
    </div>
    <ToastAlert
      :is-active="toastAlert"
      :type="typeMsg"
      :message="msg"
      @close="closeToast"
    />
    <div class="space-y-6 sm:w-[760px] sm:mb-0 mb-16">
      <!-- Header Section -->
      <div class="mb-6">
        <div class="flex items-center gap-2 mb-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <path d="M7.37273 3.948C7.97073 2.198 10.3887 2.145 11.0977 3.789L11.1577 3.949L11.9647 6.309C12.1497 6.85023 12.4485 7.34551 12.8412 7.76142C13.2338 8.17734 13.711 8.50421 14.2407 8.72L14.4577 8.801L16.8177 9.607C18.5677 10.205 18.6207 12.623 16.9777 13.332L16.8177 13.392L14.4577 14.199C13.9163 14.3838 13.4208 14.6826 13.0047 15.0753C12.5887 15.4679 12.2616 15.9452 12.0457 16.475L11.9647 16.691L11.1587 19.052C10.5607 20.802 8.14273 20.855 7.43473 19.212L7.37273 19.052L6.56673 16.692C6.38191 16.1506 6.0831 15.6551 5.69047 15.239C5.29784 14.8229 4.82052 14.4959 4.29073 14.28L4.07473 14.199L1.71473 13.393C-0.0362707 12.795 -0.0892706 10.377 1.55473 9.669L1.71473 9.607L4.07473 8.801C4.61596 8.61606 5.11124 8.31719 5.52715 7.92457C5.94307 7.53195 6.26994 7.05469 6.48573 6.525L6.56673 6.309L7.37273 3.948ZM9.26573 4.594L8.45973 6.954C8.17812 7.7793 7.72 8.5333 7.11727 9.1635C6.51453 9.79369 5.78168 10.2849 4.96973 10.603L4.71973 10.694L2.35973 11.5L4.71973 12.306C5.54503 12.5876 6.29903 13.0457 6.92923 13.6485C7.55942 14.2512 8.05065 14.9841 8.36873 15.796L8.45973 16.046L9.26573 18.406L10.0717 16.046C10.3533 15.2207 10.8115 14.4667 11.4142 13.8365C12.0169 13.2063 12.7498 12.7151 13.5617 12.397L13.8117 12.307L16.1717 11.5L13.8117 10.694C12.9864 10.4124 12.2324 9.95427 11.6022 9.35154C10.972 8.7488 10.4808 8.01595 10.1627 7.204L10.0727 6.954L9.26573 4.594ZM17.2657 0.5C17.4528 0.5 17.6361 0.552478 17.7949 0.651472C17.9536 0.750465 18.0814 0.892003 18.1637 1.06L18.2117 1.177L18.5617 2.203L19.5887 2.553C19.7762 2.6167 19.9406 2.73462 20.061 2.89182C20.1814 3.04902 20.2524 3.23842 20.265 3.43602C20.2776 3.63362 20.2313 3.83053 20.1319 4.00179C20.0326 4.17304 19.8846 4.31094 19.7067 4.398L19.5887 4.446L18.5627 4.796L18.2127 5.823C18.1489 6.01043 18.0309 6.1747 17.8737 6.29499C17.7164 6.41529 17.527 6.48619 17.3294 6.49872C17.1318 6.51125 16.9349 6.46484 16.7637 6.36538C16.5925 6.26591 16.4547 6.11787 16.3677 5.94L16.3197 5.823L15.9697 4.797L14.9427 4.447C14.7552 4.3833 14.5909 4.26538 14.4705 4.10819C14.3501 3.95099 14.2791 3.76158 14.2665 3.56398C14.2538 3.36638 14.3001 3.16947 14.3995 2.99821C14.4989 2.82696 14.6469 2.68906 14.8247 2.602L14.9427 2.554L15.9687 2.204L16.3187 1.177C16.3862 0.979426 16.5137 0.807909 16.6836 0.686499C16.8534 0.565089 17.057 0.499875 17.2657 0.5Z" fill="#FF4265"/>
          </svg>
          <h2 class="text-lg font-medium text-gray-900">
            Dale una mejora a tu descripción con 
            <span class="text-tuin-100">IA</span>
          </h2>
        </div>
        <p class="text-custom_gray text-sm font-medium leading-relaxed">
          Genera sugerencias de descripciones más llamativas con la IA y selecciona el que más te agrade
        </p>
      </div>

      <!-- Input Section -->
      <div class="space-y-4">
        <div>
          <!-- Header -->
          <button 
            @click="toggleDescriptionInput"
            class="w-full flex items-center justify-between py-2 cursor-pointer"
          >
            <h4 class="text-sm font-medium text-custom_gray">
              Descripción ingresada
            </h4>
            <svg 
              :class="['w-5 h-5 text-gray-400 transition-transform', isDescriptionExpanded && 'rotate-180']"
              fill="currentColor" 
              viewBox="0 0 20 20"
            >
              <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
            </svg>
          </button>

          <!-- Contenido con transición -->
          <transition name="fade">
            <div v-show="isDescriptionExpanded" class="pt-2 space-y-4">
              <div class="flex items-center gap-3">
                <input
                  type="radio"
                  :value="currentDescription"
                  v-model="selectedDescription"
                  class="w-4 h-4 text-tuin-100 border-gray-300 focus:ring-transparent flex-shrink-0"
                />
                <div 
                  class="flex-1 border border-gray-300 rounded-lg px-4 py-2 cursor-pointer overflow-hidden"
                  @click="selectedDescription = currentDescription"
                >
                  <div 
                    class="text-custom_gray text-base font-light break-words overflow-auto max-w-full"
                    v-html="formatDescription(currentDescription || 'Cargando descripción...')"
                  >
                  </div>
                </div>
              </div>
            </div>
          </transition>
        </div>

        <div class="flex justify-between items-center">
          <p class="font-normal text-xs text-gray-500">
            Solo tienes <span class="font-normal text-xs text-gray-500">{{ remainingAttempts }}</span> intentos
          </p>
          <svg v-if="isGenerating" aria-hidden="true" class="inline w-5 h-5 text-gray-200 animate-spin dark:text-gray-600 fill-tuin-100" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
          </svg>
        </div>

        <div class="flex justify-end items-center">
          <button
            @click="generateSuggestions"
            :disabled="!currentDescription.trim() || remainingAttempts <= 0 || isGenerating"
            class="flex items-center gap-2 px-5 py-2.5 border bg-white rounded-lg transition-colors right-0"
            :class="{
              'border-tuin-100 text-tuin-100 hover:text-white hover:border-tuin_hover hover:bg-tuin_hover': !(!currentDescription.trim() || remainingAttempts <= 0 || isGenerating),
              'border-tuin_disable text-tuin_disable cursor-not-allowed': (!currentDescription.trim() || remainingAttempts <= 0 || isGenerating)
            }"
          >
            <svg class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
              <path d="M2.66699 2.66678V6.00011H3.05499M3.05499 6.00011C3.49756 4.90553 4.29078 3.98872 5.31034 3.39336C6.32991 2.79799 7.51819 2.55772 8.68897 2.71021C9.85975 2.86269 10.9468 3.39931 11.7799 4.23597C12.613 5.07262 13.1449 6.16202 13.2923 7.33345M3.05499 6.00011H6.00033M13.3337 13.3334V10.0001H12.9463M12.9463 10.0001C12.5031 11.0941 11.7097 12.0101 10.6902 12.605C9.67075 13.1998 8.48282 13.4398 7.31239 13.2874C6.14197 13.1349 5.05512 12.5987 4.22201 11.7626C3.38891 10.9265 2.85656 9.83774 2.70833 8.66678M12.9463 10.0001H10.0003" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Generar sugerencias
          </button>
        </div>
      </div>

      <!-- Generated Suggestions Section -->
      <div v-if="suggestions.length > 0" class="space-y-4">
        <h3 class="text-base font-medium text-gray-900">Descripciones generadas</h3>
        
        <div class="space-y-4">
          <div
            v-for="(suggestion, index) in suggestions"
            :key="index"
          >
            <!-- Header -->
            <button 
              @click="toggleSuggestion(index)"
              class="w-full flex items-center justify-between py-2 cursor-pointer"
            >
              <h4 class="text-sm font-medium text-custom_gray">
                Sugerencia {{ index + 1 }}
              </h4>
              <svg 
                :class="['w-5 h-5 text-gray-400 transition-transform', expandedSuggestions[index] && 'rotate-180']"
                fill="currentColor" 
                viewBox="0 0 20 20"
              >
                <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd"/>
              </svg>
            </button>

            <!-- Contenido con transición -->
            <transition name="fade">
              <div v-show="expandedSuggestions[index]" class="pt-2 space-y-4">
                <div class="flex items-center gap-3">
                  <input
                    type="radio"
                    :id="`suggestion-${index}`"
                    :value="suggestion.editableDescription"
                    v-model="selectedDescription"
                    class="w-4 h-4 text-tuin-100 border-gray-300 focus:ring-transparent"
                  />
                  <textarea
                    v-model="suggestion.editableDescription"
                    @input="updateSelectedDescription(index)"
                    class="flex-1 border border-gray-300 rounded-lg px-4 py-2 text-custom_gray text-base font-light min-h-[150px] resize-y focus:ring-0 focus:border-gray-300"
                  ></textarea>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="hidden justify-end pt-6">
        <button
          @click="saveDescription"
          :disabled="!selectedDescription"
          class="w-full sm:w-auto px-5 py-2.5 text-sm bg-tuin-100 text-white rounded-lg hover:bg-tuin_hover disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors font-medium"
        >
          Siguiente
        </button>
      </div>
    </div>
  </div>
  
</template>

<script setup>
import { ref, onMounted, computed, reactive } from 'vue'
import axios from 'axios'
import { useStore } from 'vuex'
import LoaderTuin from "@/commond/LoaderTuin.vue";
import ToastAlert from "@/commond/ToastAlert.vue";

const props = defineProps({
  propertyId: {
    type: [String, Number],
    required: true
  }
})

const emit = defineEmits(['description-saved'])

const store = useStore()
const session = computed(() => store.getters.getUserSession)

const currentDescription = ref('')
const selectedDescription = ref('')
const remainingAttempts = ref(3)
const isGenerating = ref(false)
const suggestions = ref([])
const expandedSuggestions = reactive({})
const isDescriptionExpanded = ref(true)

let loader = ref(false);

let toastAlert = ref(false);
let typeMsg = ref("");
let msg = ref("");

onMounted(async () => {
  loader.value = true;
  await loadPropertyDescription()
})

async function loadPropertyDescription() {
  try {
    const url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${props.propertyId}`
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${session.value.token_api}`
      }
    }
    
    const response = await axios.get(url, options)
    if (response.data.resp && response.data.resp.characters.property_description) {
      currentDescription.value = response.data.resp.characters.property_description
      selectedDescription.value = response.data.resp.characters.property_description
    }
    loader.value = false;
  } catch (error) {
    console.error('Error loading property description:', error)
  }
}

async function generateSuggestions() {
  if (!currentDescription.value.trim() || remainingAttempts.value <= 0) return
  
  isGenerating.value = true
  
  try {
    const url = `${process.env.VUE_APP_API_BASE_URL}/description/${props.propertyId}`
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${session.value.token_api}`
      }
    }
    
    const response = await axios.get(url, options)

    if (response.data && response.data.descripcion && Array.isArray(response.data.descripcion)) {
      // Map API response to expected format { descripcion: [...] }
      suggestions.value = response.data.descripcion.map(descripcion => ({
        description: descripcion,
        editableDescription: descripcion
      }))
      console.log('Sugerencias generadas:', suggestions.value)
    } else if (response.data && Array.isArray(response.data)) {
      // Fallback if response is a direct array
      suggestions.value = response.data.map(descripcion => ({
        description: descripcion,
        editableDescription: descripcion
      }))
      console.log('Sugerencias generadas (fallback):', suggestions.value)
    } else {
      console.warn('Unexpected API response format:', response.data)
      suggestions.value = []
    }
    
    remainingAttempts.value--
    
    // Reset expanded states
    Object.keys(expandedSuggestions).forEach(key => {
      delete expandedSuggestions[key]
    })
    
    // Auto-expand first suggestion if there are suggestions
    if (suggestions.value.length > 0) {
      expandedSuggestions[0] = true
    }
    
  } catch (error) {
    //console.error('Error generating suggestions:', error)
    showToast("danger", "Error al generar sugerencias, intente más tarde");
  } finally {
    isGenerating.value = false
  }
}

function toggleSuggestion(index) {
  // Si la sugerencia actual está expandida, la cerramos
  if (expandedSuggestions[index]) {
    expandedSuggestions[index] = false
  } else {
    // Cerrar todas las sugerencias primero
    Object.keys(expandedSuggestions).forEach(key => {
      expandedSuggestions[key] = false
    })
    // Abrir solo la sugerencia seleccionada
    expandedSuggestions[index] = true
  }
}

function toggleDescriptionInput() {
  isDescriptionExpanded.value = !isDescriptionExpanded.value
}

function updateSelectedDescription(index) {
  // If this suggestion is currently selected, update the selected description
  if (selectedDescription.value === suggestions.value[index].description ||
      selectedDescription.value === suggestions.value[index].editableDescription) {
    selectedDescription.value = suggestions.value[index].editableDescription
  }
}

function formatDescription(description) {
  if (!description) return ''
  
  // Si ya contiene etiquetas HTML, las procesamos
  if (description.includes('<p>')) {
    return description
      .replace(/<p>/g, '<p class="mb-3 last:mb-0">')
      .replace(/<\/p>/g, '</p>')
  }
  
  // Si es texto plano con saltos de línea, lo convertimos a párrafos
  const paragraphs = description.split('\n').filter(p => p.trim())
  if (paragraphs.length > 1) {
    return paragraphs
      .map(p => `<p class="mb-3 last:mb-0">${p.trim()}</p>`)
      .join('')
  }
  
  // Si es un solo párrafo, lo envolvemos en <p>
  return `<p class="mb-0">${description}</p>`
}

async function saveDescription() {
  if (!selectedDescription.value) return
  
  try {
    const url = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${session.value.id}/update_title_description`;
    const options = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${session.value.token_api}`
      }
    }
    
    const data = {
      property_id: props.propertyId,
      description: selectedDescription.value
    }
    
    await axios.post(url, data, options)
    emit('description-saved', selectedDescription.value)
    showToast("success", "Descripción guardada exitosamente");
    // Show success message
    console.log('Descripción guardada exitosamente')
    return true;
  } catch (error) {
    console.error('Error saving description:', error)
    return false;
  }
}

async function closeToast() {
  toastAlert.value = false;
  typeMsg.value = "";
  msg.value = "";
}

async function showToast(type, message){
  toastAlert.value = true;
  typeMsg.value = type;
  msg.value = message;

  setTimeout(() => {
    closeToast()
  }, 3000);
}

// Exponer el método saveDescription para que pueda ser llamado desde el componente padre
defineExpose({
  saveDescription
});
</script>

<style scoped>
/* Custom styles */
.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.line-clamp-3 {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.rotate-180 {
  transform: rotate(180deg);
}

.break-words {
  word-break: break-word;
  overflow-wrap: anywhere;
}
</style>